import type { SelectedBookData } from "p6m-p6u";
import { useHistory } from "react-router-dom";
import { useTestCreationContext } from "../context/TestCreationContext";
import { useLogger } from "./useLogger";

/**
 * Takes over the book picked in a book selection: drops the drawer's book vocabulary when the band
 * changed, stores the book, logs "Book Confirmed" and continues to the vocabulary selection.
 */
export const useConfirmBook = () => {
    const { selectedBookData, setSelectedBookData, vocabularyDrawerContent, removeContentFromVocabularyDrawer } =
        useTestCreationContext();
    const { logEvent } = useLogger();
    const history = useHistory();

    return (book: SelectedBookData, eventProperties: Record<string, unknown> = {}) => {
        if (
            selectedBookData?.band &&
            selectedBookData.band.UUID !== book.band?.UUID &&
            Object.keys(vocabularyDrawerContent).length > 0
        ) {
            removeContentFromVocabularyDrawer("BOOK");
        }

        setSelectedBookData({ band: book.band, publisherBook: book.publisherBook, subject: book.subject });
        logEvent("Book Confirmed", {
            subject: book.subject?.Name,
            subject_id: book.subject?.ID,
            band: book.band?.ShortName ?? book.band?.Name,
            band_id: book.band?.UUID,
            book_id: book.publisherBook?.CombinedID,
            publisher: book.publisherBook?.PublisherName,
            ...eventProperties,
        });
        history.push("/create/select-vocabulary");
    };
};
